import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=2be00b1b&scoped=true&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&id=2be00b1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be00b1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be00b1b')) {
      api.createRecord('2be00b1b', component.options)
    } else {
      api.reload('2be00b1b', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=2be00b1b&scoped=true&", function () {
      api.rerender('2be00b1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Product/Create.vue"
export default component.exports